module.exports = __webpack_public_path__ + "static/img/nowarea.14b96120.png";